// How an object's map is shown: as the diagram the app draws from the graph,
// or as the list of the same parts with what each one says about itself.
//
// One picture is the point - the drawn diagram is what an object opens on -
// and the list stays as the other way of reading the same map, for a reader
// who wants the descriptions and the fields rather than the shape. The choice
// belongs to the reader and follows them from one object to the next, so it
// is kept in this browser and nowhere else; until they make one, the
// database's own view setting (`diagram.generatedMap`, Console -> Views)
// decides.
//
// The reader sees these two as **Diagram | Map** (product owner, 28 Sep 2026:
// "Cards is called Map"). The stored value stays "cards" so a reader who
// already chose it keeps their choice; only the word on the button changed.

export const DIAGRAM = "diagram";
export const CARDS = "cards";

const KEY = "bf.diagram.mapPresentation";

// Storage can be missing, full, or refuse to answer in a private window, and
// none of that is a reason for a map not to open.
export function readPreference() {
  try {
    const stored = window.localStorage.getItem(KEY);
    return stored === DIAGRAM || stored === CARDS ? stored : null;
  } catch (e) {
    return null;
  }
}

export function writePreference(value) {
  try {
    if (value === DIAGRAM || value === CARDS) window.localStorage.setItem(KEY, value);
    else window.localStorage.removeItem(KEY);
  } catch (e) {
    /* a reader whose browser keeps nothing still gets this session's choice */
  }
}

// Which of the two to show: the reader's own choice, else what the database
// is configured for.
export const mapPresentationFor = (preference, drawByDefault) =>
  preference === DIAGRAM || preference === CARDS ? preference : drawByDefault === false ? CARDS : DIAGRAM;
